import { z } from 'zod/v4';

import { endpointRegistry, EndpointRegistry } from './endpointRegistry';
import { HttpEndpoint } from './HttpEndpoint';
import { RegisteredHttpEndpoint } from './types/httpTypes';
import { RemoveByValue } from './types/removeByValue';

export type ExtractRequestBody<T extends RegisteredHttpEndpoint> = z.infer<EndpointRegistry[T]['requestBody']>;

export type ExtractQueryParams<T extends RegisteredHttpEndpoint> = z.infer<EndpointRegistry[T]['queryParams']>;

export type ExtractResponseBody<T extends RegisteredHttpEndpoint> = z.infer<EndpointRegistry[T]['responseBody']>;

export function extractEndpointsToBeInvalidated(endpoint: RegisteredHttpEndpoint): HttpEndpoint[] {
    return endpointRegistry[endpoint].invalidates ?? [];
}

export function extractEndpointsToBeRemoved(endpoint: RegisteredHttpEndpoint): HttpEndpoint[] {
    return endpointRegistry[endpoint].removes ?? [];
}

export function extractActionPermission<T extends RegisteredHttpEndpoint>(
    endpoint: T,
): EndpointRegistry[T]['actionPermission'] {
    return endpointRegistry[endpoint].actionPermission;
}

export type ExtractArguments<T extends RegisteredHttpEndpoint> = {
    pathParams: z.infer<EndpointRegistry[T]['pathParams']>;
    queryParams: z.infer<EndpointRegistry[T]['queryParams']>;
    requestBody: z.infer<EndpointRegistry[T]['requestBody']>;
    requestHeaders?: {
        Authorization: string | null;
        'validated-token'?: string;
    };
    /** Aborts the request; the resulting `AbortError` is treated as a cancellation, not a network failure. */
    signal?: AbortSignal;
};

export type HttpOptions<T extends RegisteredHttpEndpoint> = RemoveByValue<ExtractArguments<T>, undefined>;

export type { RemoveByValue } from './types/removeByValue';
